import http from './http';
import config from '~/config';
import { fileUtils } from '~/util';
import crypto from 'crypto';
import FileSaver from 'file-saver';

const DEED = 1;
const CURRENT_OWNER_POLICY = 2;
const PREVIOUS_OWNER_POLICY = 3;
const CURRENT_LENDER_POLICY = 4;
const PREVIOUS_LENDER_POLICY = 5;
const TITLE_FORM = 6;
const TRYON_EXPRESS_HELP_DOCUMENT = 7;
const PTO_WORD_DOC = 8;
const COPYOFDEED = 9;
const DEED_OF_TRUST = 10;
const FTO_WORD_DOC = 11;
const PTO_ATTACHMENT = 12;
const FTO_ATTACHMENT = 13;
const PTO_PriorPolicy = 14;
const PXT_FILE = 15;
const PTO_REVISION = 16;
const STF_WORD_DOC = 17;
const STF_REVISION = 18;

export const DocumentType = Object.freeze({
    DEED,
    CURRENT_OWNER_POLICY,
    PREVIOUS_OWNER_POLICY,
    CURRENT_LENDER_POLICY,
    PREVIOUS_LENDER_POLICY,
    TITLE_FORM,
    TRYON_EXPRESS_HELP_DOCUMENT,
    PTO_WORD_DOC,
    COPYOFDEED,
    DEED_OF_TRUST,
    FTO_WORD_DOC,
    PTO_ATTACHMENT,
    FTO_ATTACHMENT,
    PTO_PriorPolicy,
    PXT_FILE,
    PTO_REVISION,
    STF_WORD_DOC,
    STF_REVISION
});

export const DocumentTypeNames = Object.freeze({
    [DEED]: 'Policy Request Deed',
    [CURRENT_OWNER_POLICY]: 'Current Owner Policy',
    [PREVIOUS_OWNER_POLICY]: 'Previous Owner Policy',
    [CURRENT_LENDER_POLICY]: 'Current Lender Policy',
    [PREVIOUS_LENDER_POLICY]: 'Previous Lender Policy',
    [PTO_WORD_DOC]: 'PTO Document',
    [COPYOFDEED]: 'PTO Attachment',
    [DEED_OF_TRUST]: 'PTO Attachment',
    [FTO_WORD_DOC]: 'FTO Document',
    [PTO_ATTACHMENT]: 'PTO Attachment',
    [FTO_ATTACHMENT]: 'FTO Attachment',
    [PTO_PriorPolicy]: 'PTO Attachment',
    [PXT_FILE]: 'Firm PXT File',
    [PTO_REVISION]: 'PTO Revision',
    [STF_WORD_DOC]: 'STF Document',
    [STF_REVISION]: 'STF Revision'
});

export const getUploadLink = async (file) => {

    const fileBlob = file.size > 4200 ? file.slice(0, 4200) : file;
    const binString = await fileUtils.readAsBinString(fileBlob);
    const md5 = crypto.createHash('md5').update(binString).digest('base64');

    const reqPayload = {
        name: file.name,
        type: file.type,
        md5,
        size: file.size,
        chunk: binString
    };

    return http.post(`${config.urls.document}/document`, reqPayload);
};

export const upload = async ({ file, uploadLink }) => {
    const fd = new FormData();
    Object.keys(uploadLink.fields)
        .forEach(field => {
            fd.append(field, uploadLink.fields[field]);
        });

    fd.append('file', file);

    try {
        const result = await http.post(uploadLink.url, fd, {
            authHeader: false,
            rawRequest: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (result.status !== 204) {
            return { success: false, message: 'Document upload failed' };
        }
        return { success: true };
    } catch (err) {
        return { success: false, message: 'Document upload failed' };
    }
};

export const getDocBase64ById = async id => {
    try {
        console.log('config.urls.document->' + config.urls.document);
        return await http.get(`${config.urls.document}/document/download/${id}`);

    } catch (err) {
        console.error(err);
        return null;
    }
};

export const download = async (doc = {}, setDownloading = null) => {
    if (doc?.id && !doc?.documentId) {
        doc.documentId = doc.id;
    }
    if (doc?.documentId == undefined || doc?.documentId == '')
        return;

    if (setDownloading) {
        setDownloading(true);
    }
    let url = await getDownloadUrl(doc?.documentId);


    fetch(url)
        .then(res => res.blob())
        .then(blob => {
            FileSaver.saveAs(blob, doc?.name);
        })
        .finally(() => {
            if (setDownloading) {
                setDownloading(false);
            }
        });
};

const getDownloadUrl = async (id = '') => {
    try {
        return getDocBase64ById(id);
    } catch (err) {
        console.error('Error downloading file: ', err);
    }
};

export default {
    DocumentType,
    DocumentTypeNames,
    getUploadLink,
    upload,
    download,
    getDocBase64ById
};